import React from "react"
import { graphql } from "gatsby"
import AboutPage from "../components/about/AboutPage"
import { LEADERSHIP } from "../data/about"
import leaderImg from "../images/about/a6eab89a.png"
import leaderImg1 from "../images/about/1736166809764.jpeg"
import leaderImg2 from "../images/about/1767898530659.jpeg"
import leaderImg3 from "../images/about/muhammad-zubair.jpg"
import leaderImg4 from "../images/about/muhammad-atique-yousaf.jpg"

/**
 * name/title/linkedin/img are unchanged from the page this redesign
 * replaces — the brief is explicit that these stay exactly as they were.
 * credentials/bio come from src/data/about.js's LEADERSHIP.overrides,
 * merged in below, so the actual wording lives in the data file like
 * everything else on this page.
 */
const LEADERS = [
  {
    name: "Dr. Muhammad Tauseef Yunis Bhutti",
    credentials: "PhD, PMP, LMC",
    title: "CEO & Co-Founder",
    linkedin: "https://www.linkedin.com/in/dr-muhammad-tauseef-yunis-phd-pmp-lmc-a4973511/",
    img: leaderImg,
  },
  {
    name: "Hasan Arif",
    credentials: "",
    title: "COO & Co-Founder",
    linkedin: "https://www.linkedin.com/in/hasan-visiomate/",
    img: leaderImg1,
  },
  {
    name: "Rabi Ullah Khan",
    credentials: "Coach, Therapist",
    title: "CHRO",
    linkedin: "https://www.linkedin.com/in/rabiullahkhann/",
    img: leaderImg2,
  },
  {
    name: "Muhammad Zubair",
    credentials: "",
    title: "Technical Delivery Lead",
    linkedin: "https://www.linkedin.com/in/zubairyounis/",
    img: leaderImg3,
    initials: "MZ",
  },
  {
    name: "Muhammad Atique Yousaf",
    credentials: "",
    title: "Manager ERP Services",
    linkedin: "https://www.linkedin.com/in/muhammad-atique-yousaf/",
    img: leaderImg4,
    initials: "MA",
  },
]

const leaders = LEADERS.map(leader => ({
  ...leader,
  ...LEADERSHIP.overrides[leader.name],
}))

const About = ({ data }) => {
  const hasPagePaths = new Set(data.allSitePage.nodes.map(n => n.path.replace(/\/$/, "")))

  return (
    <AboutPage
      heroFloorPhoto={data.heroFloorPhoto?.childImageSharp?.gatsbyImageData}
      heroDeskPhoto={data.heroDeskPhoto?.childImageSharp?.gatsbyImageData}
      heroWallPhoto={data.heroWallPhoto?.childImageSharp?.gatsbyImageData}
      storyPhoto={data.storyPhoto?.childImageSharp?.gatsbyImageData}
      odooBadge={data.odooBadge?.childImageSharp?.gatsbyImageData}
      hasPagePaths={hasPagePaths}
      leaders={leaders}
    />
  )
}

export default About

export const query = graphql`
  query AboutQuery {
    heroFloorPhoto: file(relativePath: { eq: "lifeatvisiomate/vibrent_workplace.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 900, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    heroDeskPhoto: file(relativePath: { eq: "lifeatvisiomate/good_environement1.webp" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 900, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    heroWallPhoto: file(relativePath: { eq: "lifeatvisiomate/good_environement3.webp" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 900, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    storyPhoto: file(relativePath: { eq: "about/team-complete.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 1040, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 80)
      }
    }
    odooBadge: file(relativePath: { eq: "odoo_ready_partners.png" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 300, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 90)
      }
    }
    allSitePage {
      nodes {
        path
      }
    }
  }
`
